import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flatpickr/dist/themes/material_blue.css'; // or your theme
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { useNavigate, useParams } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'




const GuestIntakeFormMoveIn = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const [isPaid, setIsPaid] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [loading, setLoading] = useState(false);

  const [moveIn, setMoveIn] = useState({
    id: id,
    move_in_date: "",
    current_invoice_period: "",
    door_code: "",
    invoice_method: "email",

  });
  
  // Load data on mount
  useEffect(() => {
    getGuest();
  }, []);



  const getGuest = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-guest/${id}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

        const g = response.data?.guest;
                if(!g.invoice_method) g.invoice_method="email";

      setIsPaid(( g?.stripe_subscription_id || g.stripe_payment_method_id ));

      setMoveIn(response.data?.guest);
     
    } catch (error) {
      globalErrorHandler(error, navigate);
    } finally {
      setLoading(false);
    }
  };


  const formatDate = (date) => {
     if (!date) return "";


     const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
  };




  const handleDiscardDoorCode = async () => {

    
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will remove the selected bed and reset the form.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, discard",
    });

    if (!confirm.isConfirmed) return;

    try {
            setIsDisabled(true);

      const response = await axios.put(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/update-guest-bed`,
        { id: moveIn.id, move_in_date: null,current_invoice_period:null,door_code:null,invoice_method:null  },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data.status) {
        Swal.fire("Discarded", "The bed selection has been cleared.", "success");

        // Reset moveIn state
        setMoveIn({
          id: id,
          move_in_date: "",
          current_invoice_period: "",
          door_code: "",
          invoice_method: "",
          
        });
      } else {
        Swal.fire("Error", response.data.message || "Failed to discard unit.", "error");
      }
            setIsDisabled(false);

    } catch (error) {
            setIsDisabled(false);

      globalErrorHandler(error, navigate);

    }
  };


  const handleSaveDoorCodeAndNext = async () => {
    const { id, move_in_date, current_invoice_period, invoice_method, door_code } = moveIn;

    if (!move_in_date || !current_invoice_period || !invoice_method || !door_code) {
      Swal.fire("Missing Fields", "Please fill all billing and door code fields.", "warning");
      return;
    }
      setIsDisabled(true);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/update-guest-billing-and-door-code`,
        {
          id,
          move_in_date,
          current_invoice_period,
          invoice_method,
          door_code,
        },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data.status) {
       // Swal.fire("Saved", "Billing and door code saved.", "success");
        navigate(`/overseer/guest-management/guest-intake-form-review/${id}`);

      } else {
        Swal.fire("Error", response.data.message || "Failed to save.", "error");
      }
            setIsDisabled(false);

    } catch (error) {
            setIsDisabled(false);

      globalErrorHandler(error, navigate);

    }
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }


  return (
    <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Guest Intake Form</h3>
      </div>


      <div className="row mb-4" >
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold"><div className="icon-circle me-2"><i className="bi bi-briefcase-fill"></i></div>Details</div>
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold "><div className="icon-circle me-2"><i className="bi bi-person-fill"></i></div>Move-In</div>
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold text-secondary"><div className="icon-circle me-2"><i className="bi bi-file-earmark-check-fill"></i></div>Review</div>

      </div>


     
        <div className="card shadow mt-4">
          <div className="card-header">
            <h5 className="mb-0">Door Code</h5>
          </div>
          <div className="card-body p-4">
            {/* Row 1: move_in_date + current_invoice_period */}
            <div className="row g-5 mb-3">
              <div className="col-md-6">
                <h5>Billing</h5>

                <div className="row g-2 mt-4">
                  <div className="col-md-6">

                    <label className="form-label fw-bold">Move-In Date<span class="text-danger">*</span></label>
               <Flatpickr
  placeholder="Select a date"
  className="form-control"
  name="move_in_date"
  options={{ dateFormat: "m/d/Y" }} // display format
  value={moveIn.move_in_date ? new Date(moveIn.move_in_date) : ""} // DB value -> Date
  onChange={([date]) =>
    setMoveIn((prev) => ({
      ...prev,
      move_in_date: date ? formatDate(date) : "", // always save Y-m-d
    }))
  }
/>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Invoice Period (Months)<span class="text-danger">*</span></label>
                    <select
                      disabled={true}
                      className="form-select"
                      name="current_invoice_period"
                      value={moveIn.current_invoice_period}
                      onChange={(e) =>
                        setMoveIn(prev => ({ ...prev, current_invoice_period: e.target.value }))
                      }
                    >
                      <option value="">Select</option>
                      {[...Array(36)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1} month{i > 0 ? "s" : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Row 2: Invoice Method */}
                <div className="row mt-4">
                  <div className="col-12 ">

                    <div className="form-check mb-3 fw-bold">
                      <input className="form-check-input" type="radio" name="invoice_method" id="invoiceEmail" value="email" checked={moveIn.invoice_method === "email"}
                        onChange={(e) =>
                          setMoveIn(prev => ({ ...prev, invoice_method: e.target.value }))
                        }
                      />
                      <label className="form-check-label" htmlFor="invoiceEmail">Receive invoices via email</label>
                    </div>

                    <div className="form-check fw-bold">
                      <input className="form-check-input" type="radio" name="invoice_method" id="invoicePrinted" value="printed" checked={moveIn.invoice_method === "printed"}
                        onChange={(e) =>
                          setMoveIn(prev => ({ ...prev, invoice_method: e.target.value }))
                        }
                      />
                      <label className="form-check-label" htmlFor="invoicePrinted">Receive printed invoices</label>

                    </div>
                  </div>
                </div>
              </div>
              {/* Row 3: Door Code */}

              <div className="col-md-6">
                <h5>Door Code</h5>
                <div className="row mt-4">
                  <div className="col-md-12 mt-2">
                    <label className="form-label">Door Code<span class="text-danger">*</span></label>
                    <input type="text" className="form-control"  name="door_code" value={moveIn.door_code}  onChange={(e) => setMoveIn(prev => ({ ...prev, door_code: e.target.value }))  } />
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-wrap gap-3 justify-content-center py-3">
              {/* Go Back */}
              <button type="button" className="btn btn-lg btn-outline-dark" onClick={() => navigate(`/overseer/guest-management/guest-intake-form-move-in/${moveIn.id}`)}  >Go Back</button>
   {/* Cancel & Discard */}

              {/* Save & Next */}
              <button type="button" className="btn btn-lg btn-dark" onClick={handleSaveDoorCodeAndNext}  disabled={isDisabled} >Save & Next</button>

            </div>

          </div>
        </div>
    
    </div>


  );
};

export default GuestIntakeFormMoveIn;
